/** SA-1034 PR 5 (spec §3.4): the dot-and-words key lines the Conversations page shows twice, for
 *  voice and, since SA-1418 (B5), for the avatar. */
import { Tip } from '@/components/ui'
import { useAuthStore } from '@/stores/authStore'
import { useSettingsStore } from '@/stores/settingsStore'
import { keyStatusWords, type KeyedService } from './voiceStatusText'

export function KeyStatusLine({ service, hasKey }: { service: KeyedService; hasKey: boolean }) {
  const viewingAs = useAuthStore((s) => s.impersonation !== null)
  const words = keyStatusWords(service, hasKey, viewingAs)
  const line = (
    <div className="flex items-center gap-1" tabIndex={words.tip ? 0 : undefined}>
      <div className={`w-2 h-2 rounded-full ${words.ok ? 'bg-success' : 'bg-warning'}`} />
      <span className="text-muted-foreground">{words.text}</span>
    </div>
  )
  return words.tip ? <Tip text={words.tip}>{line}</Tip> : line
}

export function VoiceStatusLine() {
  const hasKey = useSettingsStore((s) => s.hasElevenLabsKey)
  return <KeyStatusLine service="voice" hasKey={hasKey} />
}
